/// <amd-module name="Feed/Core/UxFeedView" />
import { Feed, FeedRole, FeedView, ProjectReference } from "Feed/Common/Contracts/Feed";

export interface IUxFeedView {
    readonly id: string;
    readonly name: string;
    readonly role: FeedRole;
    readonly project: ProjectReference | undefined;

    /**
     * If set, the user can publish packages to this feed
     */
    readonly canPublishPackages: boolean;
}

export class UxFeedView implements IUxFeedView {
    id: string;
    name: string;
    role: FeedRole;
    project: ProjectReference;
    canPublishPackages: boolean;

    constructor(feed: Feed, view?: FeedView) {
        let fromView = false;
        if (view != undefined) {
            this.id = feed.id + "@" + view.id;
            this.name = feed.name + "@" + view.name;
            fromView = true;
        } else {
            this.id = feed.id;
            this.name = feed.name;
        }

        this.project = feed.project;

        this.role = feed.permissions && feed.permissions!.length > 0 ? feed.permissions[0].role : FeedRole.None;
        this.canPublishPackages =
            fromView != true && (this.role === FeedRole.Administrator || this.role === FeedRole.Contributor);
    }
}
